import { ReactElement } from 'react';

import { Icon } from '@consumer-frontend/shared-ui';

import { NcButton } from '../NcButton';

import '@consumer-bootstrap/netcredit.scss';

export type NcVisibilityTogglePropsT = {
  hideLabel: string;
  isMasked: boolean;
  onToggle: () => void;
  showLabel: string;
};

export const NcVisibilityToggle = ({
  hideLabel,
  isMasked,
  onToggle,
  showLabel,
}: NcVisibilityTogglePropsT): ReactElement => {
  return (
    <NcButton
      aria-label={isMasked ? showLabel : hideLabel}
      className="nc-visibility-toggle"
      onClick={onToggle}
      type="button"
      variant="link"
    >
      <Icon
        className="nc-visibility-icon"
        iconName={isMasked ? 'eye' : 'eye-slash'}
      />
    </NcButton>
  );
};
